// Nombre a mostrar para un tour según su modalidad.
// PROMPT 54: "Contrastes" con modalidad VIP debe titularse "Contrastes VIP"
// (mismo criterio visual que ya existe para "Washington VIP", que es un tour
// separado en el catálogo). Solo cambia lo que se MUESTRA -- no toca catálogo,
// tarifas, salidas ni reservas. Por ahora aplica SOLO a "Contrastes" (pedido explícito).
export function nombreTourDisplay(tourNombre, modalidad) {
  if (!tourNombre) return tourNombre;
  const esVip = String(modalidad || "").toLowerCase() === "vip";
  if (esVip && tourNombre === "Contrastes") return "Contrastes VIP";
  return tourNombre;
}
